/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { z } from "zod";

export const communeSchema = z.object({
      "insee": z.string().optional(),
  "label": z.string().optional(),
  "completeLabel": z.string().optional(),
  "postalCode": z.string().optional(),
  "latitude": z.number().optional(),
  "longitude": z.number().optional()
      })